import { Component, Injector } from '@angular/core';
import { Acao, BaseResourceListComponent, Coluna, Filtro, FormatoExportacao, LoginContabil } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AcaoService } from '../service/acao.service';
import * as toastr from 'toastr';

@Component({
  selector: 'app-acao-list',
  templateUrl: './acao-list.component.html'
})
export class AcaoListComponent extends BaseResourceListComponent<Acao, LoginContabil> {

  /**
   * Declaração de variáveis
   */


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    private acaoService: AcaoService) {
    super(acaoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'ppa';
  }

  protected condicoesGrid(): {} {
    return {
      ['ppa.id']: this.login.ppa.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['id$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      number: ['id'],
      text: ['nome', 'codigo']
    };
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: Acao): Observable<Acao> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Código', coluna: 'codigo' },
      { titulo: 'Descrição', coluna: 'nome' }
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    if (this.lista?.length) {
      if (formato === 'pdf') {
        this.imprimir(`LISTAGEM DE AÇÕES GOVERNAMENTAIS`,
          this.login.usuario.nome, this.login.usuario.sobrenome, this.login.orgao.nome, this.login.brasao, 'portrait',
          'LISTAGEM DE AÇÕES GOVERNAMENTAIS', ['auto', '*'], this.lista);
      } else {
        this.exportar(formato, this.lista);
      }
    } else {
      toastr.info('Não foram encontrados registros cadastrados!')
    }
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public retornar() {
    this.router.navigate([`/cadastros-auxiliares`]);
  }
}
